'use client';

import { PageFormHeader } from '../atomic-organisms';

type FormPageShellProps = {
  title: string;
  formID: string;
  isSaving: boolean;
  cancelAriaLabel: string;
  saveAriaLabel: string;
  children: React.ReactNode;
};

export function FormPageShell({
  title,
  formID,
  isSaving,
  cancelAriaLabel,
  saveAriaLabel,
  children,
}: FormPageShellProps) {
  return (
    <section
      style={{
        display: 'grid',
        gap: '1rem',
        margin: '0 auto',
        maxWidth: 'var(--nn-global-max-width)',
        padding: '0.3rem',
        width: '100%',
        overflowY: 'scroll',
        overscrollBehavior: 'contain',
      }}
    >
      <PageFormHeader
        title={title}
        formID={formID}
        isSaving={isSaving}
        cancelAriaLabel={cancelAriaLabel}
        saveAriaLabel={saveAriaLabel}
      />

      {children}
    </section>
  );
}
